<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!--    <div class="header-top container-fuild hidden-xs">-->
    <!--      <div class="container">-->
    <!--        <div class="server pull-left">-->
    <!--          <span class="glyphicon glyphicon-earphone"></span>888-888-888-->
    <!--          <span class="glyphicon glyphicon-envelope"></span>liyunkun_11@163.com-->
    <!--          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务-->
    <!--        </div>-->
    <!--        <div class="shejiao pull-right">-->
    <!--          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！-->
    <!--          <span class="glyphicon glyphicon-hand-left"></span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!-- 电脑导航 -->
    <div class="header-nav hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo_mingshuo.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
        >
          <router-link :to="item.path"   @click.native="navClick(index,item.name)">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
<!--      <div class="header-nav-m-logo">-->
<!--        <img class="center-block" src="@/assets/img/logo_mingshuo.png" alt="logo">-->
<!--      </div>-->
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center" style="display: flex;justify-content: flex-start">
        <div style="width: 50%;display: flex;align-items: center">
          <img src="@/assets/img/logo_mingshuo.png" alt="logo" style="width: 100%">
        </div>
        <p style="width: 35%;text-align: right">{{menuName}}</p>
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path"  @click.native="navClick(index,item.name)">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "走进明槊",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "产品中心",
          path: "/software",
          children: [
            // {
            //   name: "智能小镇管理系统",
            //   path: "/software/smartTown"
            // },
            // {
            //   name: "大数据管理系统",
            //   path: "/software/bigData"
            // }
          ]
        },
        {
          name: "解决方案",
          path: "/service",
          children: []
        },
        {
          name: "应用案例",
          path: "/applicationCases",
          children: []
        },
        {
          name: "业务合作",
          path: "/cooperation",
          children: []
        },
        {
          name: "新闻资讯",
          path: "/newsinformation",
          children: []
        },

        {
          name: "招聘信息",
          path: "/jobchance",
          children: []
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: []
        }
      ]
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  width: 100%;
  background: rgba(68,68,68,.9);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  height: 75px;
  background: url("https://shareimage.foxshare.city/homepage-assets/images/navbg.jpg") no-repeat;
  background-size:100% 100%;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 15%;
  min-width: 250px;
  height: 100%;
  display: flex;
  align-items: center;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 100%;
  height: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 75px;
  margin: 0;
  max-width: 1200px;
  display: flex;
  flex: 1;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  flex: 1;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #fff;
  font-size: 18px;
  font-weight: 200;
  padding: 10px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 3px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #ff6e00;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #ff6e00;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #ff6e00;
  text-decoration: none;
  border-bottom: 4px solid #ff6e00;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header {
    z-index: 999999;
  }
  #header .header-nav-m {
    position: relative;
    background: #ffffff;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    right: 0;
    width: 50%;
    text-align: center;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue